'use client';

import { AspectRatio, Center, Text } from '@chakra-ui/react';

interface AdditionalProductsCardProps {
  count: number;
}

export default function AdditionalProductsCard({
  count,
}: AdditionalProductsCardProps) {
  if (count <= 0) return null;

  return (
    <AspectRatio
      ratio={1}
      w='48px'
      rounded={8}
      bg='background'
      overflow='hidden'
      position='relative'
    >
      <Center w='100%' h='100%' bg='gray.100'>
        <Text color='text'>+{count}</Text>
      </Center>
    </AspectRatio>
  );
}
